import React, { Component, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";

import { getProductSearchResultforTransfer } from "../../actions/productDetails";
import { createWordrobeItem, updateWordrobeItem } from "../../actions/wordrobe";
import { updateVariation } from "../../actions/variableProductAction";
import { createTransferItem, getTransferItembyTransfernProduct, updateTransferItem, deleteTransferItem } from "../../actions/transfer";
import { getAllTag } from "../../actions/Inventory/tagAction"; 
import { getAllBrand } from "../../actions/Inventory/brandAction";
import {
  Layout,
  Breadcrumb,
  Divider,
  AutoComplete,
  Row,
  Col,
  Image,
  Affix,
  Form,
  Input,
  InputNumber,
  Button,
  Space,
  TreeSelect,
  Spin,
  message,
  Select,

} from "antd";
const { Content } = Layout;

const Dashboard = ({
  details,
  cartItems,
  setrefresh,
  setLoading,
  getProductSearchResultforTransfer,
  wordrobeitems,
  createWordrobeItem,
  updateWordrobeItem,
  updateVariation,
  from,
  Loactions,
  Auth,
  transfervoucher,
  List,
  refresh,
  createTransferItem,
  getTransferItembyTransfernProduct, updateTransferItem, deleteTransferItem,
  Tags,      
  Brands, 
  getAllTag, 
  getAllBrand,
}) => {
  const [cart, setCart] = useState(false);
  const transferquantity = useRef(1);
  const location = useRef("");
  const [searchresult, setsearchresult] = useState([]);
  const BarcodeInput = useRef(null);
  const barcode = useRef();
  const [form] = Form.useForm();

  const showresult = useRef(true);
  const spinning = useRef(false);

  const [selectedTag, setSelectedTag] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    getAllTag(); 
    getAllBrand(); 
  }, []);

  const onKeyUp = (event) => {
    if (event.keyCode == 13) {
      spinning.current = true;
      getProductSearchResultforTransfer(
        event.target.value, 
        from.current,
        1,
        10,
        "",
        "",
        "",
        "",
        selectedTag,    
        selectedBrand    
      ).then((result) => {
        spinning.current = false;
        setsearchresult(result.results);
        showresult.current = true;
          if (result.count == 1) {
            result.results.map((item) => {
              console.log(item);
              let flag = 0;
              //cheking the existing record
              cartItems.current.map((cart, index) => {
                if (cart.id == item.id) {
                  // if match
                  cartItems.current[index].quantity =
                    cartItems.current[index].quantity +
                    transferquantity.current;
                  if (transferquantity.current > item.quantity) {
                    // if the limit is over
                    cartItems.current[index].quantity =
                      cartItems.current[index].quantity -
                      transferquantity.current;
                    alert("Not enough product");
                    flag = 1;
                  } else {
                    flag = 1;
                    getTransferItembyTransfernProduct(transfervoucher.current.id, item.id).then(e => {
                      let formData = new FormData();
                      formData.append("quantity", cartItems.current[index].quantity);
                      updateTransferItem(e[0].id, formData).then(e => {
                        message.success(item.Deatils[0].product_code + " has been added");
                        form.resetFields();
                        setTimeout(() => BarcodeInput.current.focus(), 0);
                        setrefresh(!refresh);
                      })
                    })

                  }
                  transferquantity.current = 1;
                }
              });
              if (flag == 0) {
                const arr = {
                  id: item.id,
                  title: item.Deatils[0].title,
                  product_code: item.Deatils[0].product_code,
                  color: item.color,
                  Color: item.Color,
                  size: item.size,
                  Size: item.Color,
                  quantity: transferquantity.current,
                  limit: item.quantity,
                  Brand: item.Deatils[0].brand_name,
                };
                let formData = new FormData();
                formData.append("transfer", transfervoucher.current.id);
                formData.append("product", item.id);
                formData.append("quantity", transferquantity.current);
                formData.append("is_received", false);
                formData.append("data", "");
                createTransferItem(formData).then(e => {
                  message.success(
                    item.Deatils[0].product_code + " has been added"
                  );
                })
                cartItems.current.push(arr);
                transferquantity.current = 1;

                message.success(item.Deatils[0].product_code + " has been added");
                form.resetFields();
                setTimeout(() => BarcodeInput.current.focus(), 0);
                setrefresh(!refresh);
              }
            });
          }
        }
      );
    }
  };

  const handleSearchWithFilters = () => {
    setIsSearching(true);
    spinning.current = true;
    showresult.current = false;
    
    getProductSearchResultforTransfer(
      barcode.current || "", 
      from.current,
      1,
      10,
      "",
      "",
      "",
      "",
      selectedTag,
      selectedBrand
    ).then((result) => {
      spinning.current = false;
      setIsSearching(false);
      setsearchresult(result.results);
      showresult.current = true;
      message.success(`Found ${result.results.length} products`);
    }).catch((error) => {
      spinning.current = false;
      setIsSearching(false);
      message.error("Search failed");
    });
  };

  const handleClearFilters = () => {
    setSelectedTag("");
    setSelectedBrand("");
    form.setFieldsValue({ tag: undefined, brand: undefined });
    setsearchresult([]);
    showresult.current = false;
  };

  useEffect(() => {
    setCart(false);
  }, [cart, refresh]);


  return (
    <>
      <Row>
        {transfervoucher.current == "" ?

          <Col style={{ width: "96%" }}>
            {Auth.superuser ||
              Auth.profile.user_role.id == 33 ||
              Auth.profile.user_role.id == 6 ||
              Auth.profile.user_role.id == 35 ||
              Auth.profile.user_role.id == 13 ||
              Auth.profile.user_role.id == 29 ? (
              <Form.Item name="Merchandiser" label="From">

                <TreeSelect
                  treeData={Loactions}
                  onChange={(value) => {
                    from.current = value;
                    cartItems.current = [];
                    setrefresh(true);
                    getProductSearchResultforTransfer(
                      barcode.current,
                      from.current
                    ).then((result) => {
                      showresult.current = true;
                    });
                  }}
                />
              </Form.Item>
            ) : (
              <></>
            )}
          </Col>
          :
          <Col span={24}>
            <h3>Challan no: {transfervoucher.current.tansfer_number}</h3>
            <p>Title: {transfervoucher.current.reference}</p>
            <p>From: {transfervoucher.current.Source[0].name}</p>
            <p>To: {transfervoucher.current.Destance[0].name}</p>
            <Divider />

            <h3>Add Product</h3>
           <Form form={form} layout="vertical">
              {/* FILTER INPUTS */}
              <Row gutter={16}>
                <Col span={7}>
                  <Form.Item name="tag" label="Filter by Tag">
                    <Select
                      placeholder="Select Tag"
                      allowClear
                      showSearch
                      onChange={(value) => setSelectedTag(value || "")}
                    >
                      {Tags && Tags.map(tag => (
                        <Select.Option key={tag.id} value={tag.name}>
                          {tag.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item name="brand" label="Filter by Brands">
                    <Select
                      placeholder="Select Brand"
                      allowClear
                      showSearch
                      onChange={(value) => setSelectedBrand(value || "")}
                      filterOption={(input, option) => {
                        if (option && option.children) {
                          return option.children.toLowerCase().includes(input.toLowerCase());
                        }
                        return false;
                      }}
                    >
                      {Brands && Brands.map(brand => (
                        <Select.Option key={brand.id} value={brand.id}>
                          {brand.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item label="&nbsp;">
                    <Button 
                      type="primary"
                      loading={isSearching}
                      onClick={handleSearchWithFilters}
                      block
                    >
                      Search
                    </Button>
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item label="&nbsp;">
                    <Button 
                      onClick={handleClearFilters}
                      block
                    >
                      Clear Filters
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item 
                name="remarks" 
                label="Add Product" 
                style={{ marginBottom: "0px", fontWeight: "700" }}
              >
                <AutoComplete
                  ref={BarcodeInput}
                  placeholder="input search text"
                  onKeyUp={onKeyUp}
                  onChange={(value) => {
                    barcode.current = value;
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Form>
            <div
              style={{
                position: "absolute",
                width: "100%",
                zIndex: "5",
              }}
            >
              {searchresult.map((item, index) => {
                console.log(item);
                if (showresult.current) {
                  if (index < 10) {
                    return (
                      <>
                        <Row
                          style={{
                            width: "100%",
                            border: "1px solid lightgray",
                            padding: "5px",
                            borderRadius: "5px",
                            backgroundColor: "whitesmoke",
                          }}
                        >
                          <Col span={9} style={{ margin: "auto" }}>
                           {item.Deatils[0].tag_names} {item.Deatils[0].product_code} 
                          </Col>
                          {/* <Col span={4} style={{ margin: "auto" }}>
                            Tag: {item.Deatils[0].tag_names}
                          </Col> */}
                          <Col span={4} style={{ margin: "auto" }}>
                            Batch: {item.batch_no}
                          </Col>
                          <Col span={3} style={{ margin: "auto" }}>
                            Size: {item.color}  {item.size}
                          </Col>
                          <Col span={3} style={{ margin: "auto" }}>
                            Stock : {item.quantity}
                          </Col>
                          <Col span={4} style={{ margin: "auto" }}>
                            <Space>
                              <Button
                                type="primary"
                                onClick={() => {
                                  let flag = 0;
                                  //cheking the existing record
                                  cartItems.current.map((cart, index) => {
                                    if (cart.id == item.id) {
                                      // if match
                                      cartItems.current[index].quantity =
                                        cartItems.current[index].quantity +
                                        transferquantity.current;
                                      if (
                                        cartItems.current[index].quantity >
                                        item.quantity
                                      ) {
                                        // if the limit is over
                                        cartItems.current[index].quantity =
                                          cartItems.current[index].quantity -
                                          transferquantity.current;
                                        alert("Not enough product");
                                        flag = 1;
                                      } else {
                                        getTransferItembyTransfernProduct(transfervoucher.current.id, item.id).then(e => {
                                          let formData = new FormData();
                                          formData.append("quantity", cartItems.current[index].quantity);
                                          updateTransferItem(e[0].id, formData).then(e => {
                                            message.success(item.Deatils[0].product_code + " has been added");
                                          })
                                        })
                                        transferquantity.current = 1;
                                        flag = 1;
                                      }

                                    }
                                  });
                                  if (flag == 0) {
                                    const arr = {
                                      id: item.id,
                                      title: item.Deatils[0].title,
                                      product_code: item.Deatils[0].product_code,
                                      color: item.color,
                                      Color: item.Color,
                                      size: item.size,
                                      Size: item.Color,
                                      quantity: transferquantity.current,
                                      limit: item.quantity,
                                      Brand: item.Deatils[0].brand_name,
                                    };
                                    let formData = new FormData();
                                    formData.append("transfer", transfervoucher.current.id);
                                    formData.append("product", item.id);
                                    formData.append("quantity", transferquantity.current);
                                    formData.append("is_received", false);
                                    formData.append("data", "");
                                    createTransferItem(formData).then(e => {
                                      message.success(
                                        item.Deatils[0].product_code + " has been added"
                                      );
                                    })
                                    cartItems.current.push(arr);
                                    transferquantity.current = 1;
                                  }
                                  setTimeout(() => BarcodeInput.current.focus(), 0);
                                  form.resetFields();
                                  setrefresh(!refresh);
                                }}
                              >
                                Add to list
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </>
                    );
                  }
                }
              })}
            </div>
          </Col>
        }
      </Row>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.ProductDetails.productdetails,
    Auth: state.auth,
    Brands: state.brand.brandlist || [],
    Tags: state.tag.taglist || [],

  };
};

export default connect(mapStateToProps, {
  getProductSearchResultforTransfer,
  createWordrobeItem,
  updateVariation,
  updateWordrobeItem,
  createTransferItem,
  getTransferItembyTransfernProduct, updateTransferItem, deleteTransferItem,
  getAllTag,
  getAllBrand, 
})(Dashboard);